import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=4e6b1ff2&scoped=true&"
import script from "./dashboard.vue?vue&type=script&lang=js&"
export * from "./dashboard.vue?vue&type=script&lang=js&"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=4e6b1ff2&prod&lang=scss&scoped=true&"
import style1 from "./dashboard.vue?vue&type=style&index=1&id=4e6b1ff2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6b1ff2",
  null
  
)

export default component.exports